import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Discount, Content } from '../../models/models';
import { DiscountClient, IAttachClientData } from '../../models/ApiAccess';

@Injectable()
export class DiscountService {
  protected basePath = environment.basePath;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  /**
   * Delete
   * @param discountId
   */
  public delete(discountId: number): Observable<Discount> {
    return this.http.delete<Discount>(
      `${this.basePath}/v1/resources/discount/${discountId}`,
      this.httpOptions
    );
  }

  /**
   * Store
   * @param body
   */
  public store(body?: Discount): Observable<Discount> {
    return this.http.post<Discount>(
      `${this.basePath}/v1/resources/discount`,
      JSON.stringify(body),
      this.httpOptions
    );
  }

  /**
   * Update
   * @param body
   * @param discountId
   */
  public update(discountId: number, body?: any): Observable<Discount> {
    return this.http.put<Discount>(
      `${this.basePath}/v1/resources/discount/${discountId}`,
      JSON.stringify(body),
      this.httpOptions
    );
  }

  /**
   * Index
   * @param page
   * @param name
   * @param type
   * @param orderby_column
   * @param orderby_direction
   */
  public index(
    page: number,
    search?: string,
    type?: string,
    orderby_column: string = 'id',
    orderby_direction: 'DESC' | 'ASC' = 'DESC'
  ): Observable<Content<Discount>> {
    let queryParameters = new HttpParams({
      fromObject: {
        page: page,
        ...(search != null && { search: search }),
        ...(type != null && { type: type }),
        ...(orderby_column != null && { orderby_column: orderby_column }),
        ...(orderby_direction != null && {
          orderby_direction: orderby_direction,
        }),
      },
    });

    return this.http.get<Content<Discount>>(
      `${this.basePath}/v1/resources/discount`,
      {
        params: queryParameters,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  /**
   * View
   * @param discountId
   */
  public view(discountId: number): Observable<Discount> {
    return this.http.get<Discount>(
      `${this.basePath}/v1/resources/discount/${discountId}`,
      this.httpOptions
    );
  }

  /**
   * Attach Client to discount
   * @param discountId
   * @param clientsData
   */
  public attachClientToDiscount(
    discountId: number,
    clientsData: IAttachClientData[]
  ): Observable<any> {
    return this.http.post<any>(
      `${this.basePath}/v1/discount/attach-clients/${discountId}`,
      {
        client_ids: clientsData,
      },
      this.httpOptions
    );
  }

  /**
   * Detach Client on Discount
   * @param clientId
   * @param discountId
   * @param clientsData
   */
  public detachClientFromDiscount(
    clientId: number,
    discountId: number
  ): Observable<any> {
    return this.http.delete<any>(
      `${this.basePath}/v1/discount/detach-clients/${clientId}/${discountId}`,
      this.httpOptions
    );
  }

  /**
   * ListDiscountClients
   * @param page
   * @param discountId
   * @param search
   */
  public listDiscountClients(
    page: number,
    discountId: number,
    search?: string
  ): Observable<DiscountClient[]> {
    let queryParameters = new HttpParams({
      fromObject: {
        page: page,
        ...(search != null && { search: search }),
      },
    });

    return this.http.get<DiscountClient[]>(
      `${this.basePath}/v1/discount/list-clients/${discountId}`,
      {
        params: queryParameters,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }
}
